var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
import { getObservableT } from "../Infra/i18next";
const t = getObservableT("patients");
export class PatientConsentVerifiedViewModel extends PatientConsentViewModel {
    constructor(container) {
        super(container);
        this.patientConsentUIManager = container.patientConsentUIManager;
    }
    get findRecordsText() {
        return this.isDataUpdate ? t("Find your most recent records") : t("Confirm access and find records");
    }
    get shareRecordsText() {
        return this.isIAS
            ? t("Review and access your records")
            : this.isAIFlow
                ? t("Review and connect your records")
                : t("Review and share your records");
    }
    get isWelcomeBack() {
        return !!this.patientConsentUIManager.session.continueWhereILeftOffRoute;
    }
    get title() {
        return this.isWelcomeBack
            ? t("Welcome back, {{ patientName }}", { patientName: this.patientName })
            : t("You’re verified, {{ patientName }}", { patientName: this.patientName });
    }
    get supportingText() {
        if (this.isWelcomeBack) {
            if (this.isAIFlow) {
                return t("You began connecting your records earlier. Resume where you left off, or continue to the next step.");
            }
            if (this.isIAS) {
                return t("You began accessing your records earlier. Resume where you left off, or continue to the next step.");
            }
            return this.isDataUpdate
                ? t("You began sharing your most recent records earlier. Resume where you left off, or continue to the next step.")
                : t("You began sharing your records earlier. Resume where you left off, or continue to the next step.");
        }
        return t("We successfully verified your identity. Next, let’s confirm access.");
    }
    continueWhereILeftOff() {
        this.patientConsentUIManager.goToSavedWelcomeBackPage();
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentVerifiedViewModel.prototype, "findRecordsText", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentVerifiedViewModel.prototype, "shareRecordsText", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentVerifiedViewModel.prototype, "isWelcomeBack", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentVerifiedViewModel.prototype, "title", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentVerifiedViewModel.prototype, "supportingText", null);
